import { Box } from '@material-ui/core'
import styled from 'styled-components'

export const StyledBox = styled(Box)`
  border-top: 1px #e5e8f5 solid;
`
/* color: ${colors.orange};
    stroke: ${colors.orange}; */
